export const AUTH_CODES = {
    ACCESS_TOKEN: 'ACCESS_TOKEN',
    USER_DATA: 'USER_DATA',
    USER_PHOTO: 'USER_PHOTO',
    ROL: 'ROL'
}

export const ERROR_CODES = {
    FORBIDDEN: 403,
    UNAUTHORIZED: 401,
    NOT_FOUND: 404
}